// extracted by mini-css-extract-plugin
export default {"singleModal":"ClientView_singleModal__3hY3V","close":"ClientView_close__Q5ioR"};